/* eslint-disable angular/di */
(function () {

  'use strict';

  angular.module('PrintixAPIDownload', [])

    .constant('APIDownloadConstants', {
      OS_WINDOWS: 'WIN',
      OS_MAC: 'MAC',
      APP_CLIENT: 'CLIENT',
      EXE: 'EXE',
      DMG: 'DMG',
      CPUARCH_X64: 'x64',
      CPUARCH_ARM64: 'arm64'
    })

    .service('APIDownload', ['$filter', 'deviceDetector', '$window', '$rootScope', 'TenantListService', '$ngBootbox', 'APIDownloadConstants', '$http',
      function ($filter, $deviceDetector, $window, $rootScope, TenantListService, $ngBootbox, APIDownloadConstants, $http) {

        const APIDownloadPrivate = {};
        APIDownloadPrivate.WindowsClientX64 = null;
        APIDownloadPrivate.WindowsClientArm64 = null;
        APIDownloadPrivate.MacClient = null;
        APIDownloadPrivate.WindowsClientEXE = null;
        APIDownloadPrivate.WindowsClientMSI = null;
        APIDownloadPrivate.WindowsRedirectorEXE = null;
        APIDownloadPrivate.MacClientDMG = null;
        APIDownloadPrivate.detectedOS = $filter('uppercase')($filter('limitTo')($deviceDetector.os, 3));

        this.isWindowsOs = APIDownloadPrivate.detectedOS === APIDownloadConstants.OS_WINDOWS;
        this.isMacOs = APIDownloadPrivate.detectedOS === APIDownloadConstants.OS_MAC;
        this.isUnsupportedOs = !this.isWindowsOs && !this.isMacOs;

        this.downloadClient = function (os, cpuArch) {
          let url;
          if (os === APIDownloadConstants.OS_WINDOWS) {
            if (cpuArch === APIDownloadConstants.CPUARCH_ARM64) {
              url = APIDownloadPrivate.WindowsClientArm64;
            } else {
              url = APIDownloadPrivate.WindowsClientX64;
            }
          } else if (os === APIDownloadConstants.OS_MAC) {
            url = APIDownloadPrivate.MacClient;
          }

          if (url) {
            $window.open(url, '_self');
          }
        };

        APIDownloadPrivate.setURLS = function () {
          if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
            $http.get(TenantListService.currentTenant.info._links['px:software'].href).then(function (response) {
              if (response && response.data && response.data._embedded && response.data._embedded['px:softwareResources'] && response.data._embedded['px:softwareResources'].length > 0) {

                const windowClientFileObject = $filter('filter')(response.data._embedded['px:softwareResources'], {
                  appl: APIDownloadConstants.APP_CLIENT,
                  os: $filter('uppercase')(APIDownloadConstants.OS_WINDOWS)
                })[0];
                if (windowClientFileObject) {
                  APIDownloadPrivate.WindowsClientX64 = $filter('filter')(windowClientFileObject.files, function (file) {
                    return file.type === APIDownloadConstants.EXE && (file.cpuArch === null || file.cpuArch === APIDownloadConstants.CPUARCH_X64);
                  })[0].path;
                  APIDownloadPrivate.WindowsClientArm64 = $filter('filter')(windowClientFileObject.files, function (file) {
                    return file.type === APIDownloadConstants.EXE && (file.cpuArch !== null || file.cpuArch === APIDownloadConstants.CPUARCH_ARM64);
                  })[0].path;
                }

                const macClientFileObject = $filter('filter')(response.data._embedded['px:softwareResources'], {
                  appl: APIDownloadConstants.APP_CLIENT,
                  os: $filter('uppercase')(APIDownloadConstants.OS_MAC)
                })[0];
                if (macClientFileObject) {
                  APIDownloadPrivate.MacClient = $filter('filter')(macClientFileObject.files, { type: APIDownloadConstants.DMG })[0].path;
                }
              }
            });
          }
        };

        const unwatchCurrentTenant = $rootScope.$watch(function () {
          return TenantListService.currentTenant;
        }, function () {
          if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
            APIDownloadPrivate.setURLS();
            unwatchCurrentTenant();
          }
        });
      }]);
})();
